import { createAction, props, union } from '@ngrx/store';
import { IPlColumnEntry } from '../pl.types';

const source = 'pl';
const actions = 'api';

export const plColumnLoadRequested = createAction(
    `[${source}][${actions}] PL load column requested`,
    props<{ entries: IPlColumnEntry[] }>()
);
export const plColumnLoaded = createAction(
    `[${source}][${actions}] PL column loaded`,
    props<{ entries: IPlColumnEntry[] }>()
);

export const plAddColumnRequested = createAction(
    `[${source}][${actions}] PL add column requested`,
    props<{ entry: IPlColumnEntry }>()
);

export const plColumnAdded = createAction(
    `[${source}][${actions}] PL column added.`,
    props<{ entry: IPlColumnEntry }>()
);

const all = union({
    plColumnLoadRequested,
    plColumnLoaded,
    plAddColumnRequested,
    plColumnAdded,
});

export type PlColmunActionsUnion = typeof all;
